import React from 'react';
import Button from '@material-ui/core/Button';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { checkValidEmail } from '../../helpers';
import SelectionList from '../SelectionList';
import NavigationTabs from '../nav/NavigationTabs';
import { ASSIGN_CLIENTS_MESSAGE } from '../../static-content';
import ClientsListing from './ClientsListing';
import { COLORS } from '../../styles/colors';
import Modal from '@material-ui/core/Modal';
import ModalHeading from './../../components/ModalHeading';
import Moment from 'react-moment';
import { AlertJsMessage, paginationLimit } from './../../helpers.js';
import RestrictFeature  from './../membershipPlan/restrictFeature'
import { resetBlock } from '../../store/actions/blocks';


class ClientsForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			categoryId: '0',
			tab: 0,
			search: '',
			itemType: 'workout',
			clientType: 'clients',
			assigns: [],
			dataLoaded: false,
			openAddModal: false,
			newGroupName: '',
			selectedItems: {},
			openAlreadyAssignModal: false,
			alreadyAssignedList: [],
			editData: undefined,
			newClientId: null,
			seltectedClients: {},
			seltectedGroups: {},
			formData: {
				groupIds: [],
				clientIds: [],
				emails: '',
				message: '',
				firstName: '',
				lastName: '',
				_id: undefined,
			},
			isOpenActionModal: false,
			isOpenRestrictFeatureModal: false
		};
	}

	componentDidMount() {
		this.props.fetch().then(() => {
			this.fetchListing({})
		});
	}

	fetchListing = (query) => {
		const func = this.state.clientType === 'clients' ? 
				this.props.fetchClients 
				: this.props.fetchGroups;
		func({
			limit: paginationLimit.TEN,
			skip: query.skip ? query.skip : 0,
			search: query.search
		}).then((data) => {
		  this.setState({
			...this.state,
			dataLoaded: true,
		  })
		});
	};

	createGroupSubmit(newGroupName, formData) {
		if (!newGroupName.trim()) {
			AlertJsMessage('Please Insert a new Group Name.');
			return;
		}
		if (!this.validateEmails()) {
			return;
		}
		this.createGroup(newGroupName, formData);
	}

	saveData = () => {
		const { newGroupName, formData, clientType } = this.state;
		this.setState({ newClientId: null });
		if (clientType === 'groups') {
			this.createGroupSubmit(newGroupName, formData);
		} else if (clientType === 'clients') {
			const required = ['firstName', 'lastName'];
			for (var i = 0; i < required.length; i++) {
				if (!formData[required[i]]) {
					AlertJsMessage(
						required[i] === 'firstName'
							? 'First Name is required.'
							: 'Last Name is required.'
					);
					return;
				}
			}
			if (!this.validateEmails()) {
				return;
			}
			this.createClient(formData);
		}
	};

	createGroup = (newGroupName, formData) => {
		const { user, createGroup } = this.props;
		const newGroupData = {
			trainerId: user._id,
			name: newGroupName,
			emails: formData.emails.split(','),
		};
		if (formData._id) {
			newGroupData._id = formData._id;
		}
		createGroup(newGroupData).then(newGroup => {
			//after saving the group, then update the list and select the new group
			let seltectedGroups = this.state.seltectedGroups;
			seltectedGroups[newGroup._id.toString()] = newGroup;
			this.setState(
				{
					clientType: 'groups',
					newClientId: newGroup._id,
					seltectedGroups:seltectedGroups,
					formData: {
						...this.state.formData,
						emails: '',
						groupIds: [
							...this.state.formData.groupIds,
							newGroup._id.toString(),
						],
					},
				},
				() => {
					this.hideAddModal();
					this.fetchListing({});
				}
			);
		});
	};

	createClient = formData => {
		const { user, createClient } = this.props;
		const newClientData = {
			trainerId: user._id,
			firstName: formData.firstName,
			lastName: formData.lastName,
			email: formData.emails.split(',')[0],
		};
		if (formData._id) {
			newClientData._id = formData._id;
		}
		createClient(newClientData).then(newClient => {
			
			let seltectedClients = this.state.seltectedClients;
			seltectedClients[newClient._id.toString()] = newClient;

			this.setState(
				{
					clientType: 'clients',
					newClientId: newClient._id,
					seltectedClients: seltectedClients,
					formData: {
						...this.state.formData,
						emails: '',
						clientIds: [
							...this.state.formData.clientIds,
							newClient._id.toString(),
						],
					},
				},
				() => {
					this.hideAddModal();
					this.fetchListing({});
				}
			);
		});
	};

	handleFormChecks = (field, data) => event => {
		const { formData } = this.state;
		const { checked, value } = event.target;

		let newList = formData[field];

		if (checked) {
			newList.push(value);
		} else {
			newList = newList.filter(id => {
				return id !== value;
			});
		}

		let { seltectedClients, seltectedGroups } = this.state;
		if (field === 'clientIds') {
			if (checked) {
				if (this.props.clients[value]) {
					seltectedClients[value] = this.props.clients[value];
				}
			} else {
				delete seltectedClients[value]
			}
		}

		if (field === 'groupIds') {
			if (checked) {
				if (this.props.groups[value]) {
					seltectedGroups[value] = this.props.groups[value];
				}
			} else {
				delete seltectedGroups[value]
			}
		}

		this.setState({
			...this.state,
			seltectedClients,
			seltectedGroups,
			formData: {
				...formData,
				[field]: newList
			},
		});
	};

	handleChange = event => {
		const { name, value } = event.target;
		if (name === 'groupName') {
			this.setState({ newGroupName: value });
			return;
		}
		this.setState({
			formData: {
				...this.state.formData,
				[name]: value,
			},
		});
	};

	validateEmails(type) {
		const { formData, clientType } = this.state;
		let returnObj = true;
		if (formData.emails !== '') {
			const emailArr = formData.emails.split(',');
			const errorMail = emailArr.filter(email => !checkValidEmail(email));
			if (errorMail.length > 0) {
				AlertJsMessage(
					`The following emails are invalid. Please resolve before continuing. Note that spaces and line breaks are not allowed in email list. [${errorMail.toString()}]`
				);
				returnObj = false;
			}
		} else {
			AlertJsMessage(
				clientType === 'clients'
					? `Please add client email to save as a client.`
					: `Please add client emails to save as a group. Note that spaces and line breaks are not allowed in email list.`
			);
			returnObj = false;
		}
		return returnObj;
	}

	closeAssignModal() {
		this.setState({
			openAlreadyAssignModal: false,
		});
		const { history } = this.props;
		const { itemType } = this.state;
		if (itemType === 'program') {
			history.push('/assignments/programs');
		} else {
			history.push('/assignments/workout');
		}
	}

	saveAssignData(assigns) {
		const { itemType } = this.state;
		const { history } = this.props;
		this.props.assignEmails(assigns).then(data => {
			if (itemType === 'automation') {
				history.push('/assignments/automations');
			} else {
				if (data.length > 0) {
					let list = [];
					let uniqueItems = [];
					data.forEach(item => {
						const _id = item.workoutId;
						if (uniqueItems.indexOf(_id) < 0) {
							uniqueItems.push(_id);
							list.push({
								_id: _id,
								name: item.name,
								item: [item],
							});
						} else {
							const findIndex = list.findIndex(item => {
								return item._id === _id;
							});
							const filterItem = list[findIndex]['item'];
							filterItem.push(item);
							list[findIndex]['item'] = filterItem;
						}
					});
					this.setState({
						alreadyAssignedList: list,
						openAlreadyAssignModal: true,
					});
				} else {
					if (itemType === 'program') {
						history.push('/assignments/programs');
					} else {
						history.push('/assignments/workout');
					}
				}
			}
		});
	}

	submitForm() {
		const { selectedItems, itemType, formData, seltectedClients, seltectedGroups } = this.state;
		console.log('selectedItems...', selectedItems)
		const { user, groups, clients } = this.props;
		if(user && user.type.includes('brand') && (user.planOption === 0 || user.planOption === 3)) {
			this.setState({
				isOpenRestrictFeatureModal: true
			})
			return;
		}
		let selectedIds = Object.keys(selectedItems);
		if (selectedIds.length < 1) {
			AlertJsMessage(
				'Please select a ' + itemType + ' from the list to continue.'
			);
			return;
		}
		let assigns = [];
		const emailArr = formData.emails.split(',');
		if (formData.emails.trim()) {
			if (!this.validateEmails()) return;
			emailArr.map(email => {
				return selectedIds.map(id => {
					return assigns.push({
						type: itemType,
						typeId: id,
						trainerId: user._id,
						clientEmail: email,
						name: selectedItems[id]['name'],
						message: formData.message,
					});
				});
			});
		} else if (formData.groupIds.length > 0) {
			formData.groupIds.map(groupId => {
				const group = seltectedGroups[groupId];
				return group && group.emails.map(email => {
					return selectedIds.map(id => {
						return assigns.push({
							type: itemType,
							typeId: id,
							trainerId: user._id,
							clientEmail: email,
							name: selectedItems[id]['name'],
							message: formData.message,
						});
					});
				});
				// groups[groupId].emails.map()
			});
	} else if (formData.clientIds.length > 0) {
			formData.clientIds.map(clientId => {
				const client = seltectedClients[clientId];
				return selectedIds.map(id => {
					return assigns.push({
						type: itemType,
						typeId: id,
						trainerId: user._id,
						clientEmail: client && client['email'],
						name: selectedItems[id]['name'],
						message: formData.message,
						automationSteps: selectedItems[id]['automationSteps'],
					});
				});
				// groups[groupId].emails.map()
			});
		} else {
			AlertJsMessage('No clients were selected.');
			return;
		}
		 this.saveAssignData(assigns);
	}

	handleToggleClient = (event, type) => {
		if (type) {
			this.setState({ 
				clientType: type, 
				newClientId: null 
			}, () => {
				this.fetchListing({});
			});
		}
	};

	handleToggleType = (event, type) => {
		if (type) {
			this.setState({
				...this.state,
				selectedItems: {},
				itemType: type,
			});
		}
	};

	showAddModal = data => {
		if (data) {
			this.setState({
				newGroupName: data.name,
				formData: {
					...this.state.formData,
					emails: data.emails ? data.emails.join(',') : data.email,
					message: '',
					firstName: data.firstName,
					lastName: data.lastName,
					_id: data._id,
				},
				isOpenAddModal: true,
			});
		} else {
			this.setState({
				newGroupName: '',
				formData: {
					...this.state.formData,
					emails: '',
					message: '',
					firstName: '',
					lastName: '',
					_id: undefined,
				},
				isOpenAddModal: true,
			});
		}
	};

	showActionModal = data => {
		this.setState({
			isOpenActionModal: true,
			selectedClientEmail: data.email
		})
	}

	showScheduleMessageModal = data => {
		const { user } = this.props;
		if(user && user.type.includes('brand') && (user.planOption !== 2 && user.planOption !== 5)) {
			this.setState({
				isOpenRestrictFeatureModal: true
			})
			return;
		}
		this.setState({
			isOpenScheduleMessageModal: true,
			selectedClientEmail: data.email
		})
	}

	hideActionModal = () => this.setState({ isOpenActionModal: false });

	hideScheduleMessageModal = () => this.setState({ isOpenScheduleMessageModal: false });
	
	hideAddModal = () => this.setState({ isOpenAddModal: false });

	renderSelectionList() {
		const { itemType, selectedItems, dataLoaded } = this.state;
		if (dataLoaded) {
			const { workouts, programs, user, workoutCats, programCats, isLoadMoreAutomations, isLoadMoreWorkouts, isLoadMorePrograms, resetWorkouts, resetPrograms, resetAutomations, automations } = this.props;
			let items =
				this.state.itemType === 'workout'
					? Object.values(workouts)
					: this.state.itemType === 'program' ? Object.values(programs) : Object.values(automations);
			let cats =
				this.state.itemType === 'workout'
					? Object.values(workoutCats)
					: Object.values(programCats);
		   let isLoadMore = this.state.itemType === 'workout' ? 
		                  isLoadMoreWorkouts: 
						  this.state.itemType === 'program' ? isLoadMoreWorkouts : isLoadMoreAutomations 
			return (
				<SelectionList
					addSelectedClass={true}
					hideTabs={[2]}
					itemType={itemType}
					maxListHeight={300}
					items={items}
					selectedItems={selectedItems}
					updateSelectedItems={selected => {
						this.setState({ ...this.state, selectedItems: selected })
					}}
					categories={cats}
					categoryField="categoryId"
					creatorTabs={true}
					fetchMore = {this.props.fetchMore}
					resetListing = { 
						this.state.itemType === 'workout' ? resetWorkouts : 
						this.state.itemType === 'program' ? resetPrograms : resetAutomations }
                 	isLoadMore = {isLoadMore}
					isClientForm = {true}
					user={user}
					fetchClientNotes={this.props.fetchClientNotes}
				/>
			);
		}
		return null;
	}

	render() {

		const {
			clientType,
			itemType,
			formData,
			isOpenAddModal,
			isOpenActionModal,
			isOpenScheduleMessageModal,
			alreadyAssignedList,
			openAlreadyAssignModal,
			selectedClientEmail,
			newGroupName,
			newClientId,
			isOpenRestrictFeatureModal
		} = this.state;
		const { groups, clients, hideTabs, user } = this.props;
		return (
			<div>
				<NavigationTabs
					title="Assign"
					subtitle="Clients"
					description={ASSIGN_CLIENTS_MESSAGE}
					set="assign"
					hideTabs = {hideTabs}
					activeRoute="/assign/clients"
				/>
				<div
					style={{
						marginTop: 25,
						display: 'flex',
						border: '1px solid ' + COLORS.grey,
					}}
				>
					<div
						style={{
							width: '50%',
							borderRight: '1px solid ' + COLORS.grey,
							padding: 10,
							paddingTop: 25,
						}}
					>
						<ToggleButtonGroup
							value={itemType}
							onChange={this.handleToggleClient}
							exclusive
						>
							<ToggleButton
								style={{ marginRight: 15 }}
								value="clients"
								selected={clientType === 'clients'}
							>
								CLIENTS
							</ToggleButton>
							<ToggleButton value="groups" selected={clientType === 'groups'}>
								GROUPS
							</ToggleButton>
						</ToggleButtonGroup>
						<ClientsListing
							clientType={clientType}
							formData={formData}
							isOpenAddModal={isOpenAddModal}
							isOpenActionModal = {isOpenActionModal}
							isOpenScheduleMessageModal = { isOpenScheduleMessageModal }
							showAddModal={this.showAddModal}
							showActionModal = { this.showActionModal}
							showScheduleMessageModal = { this.showScheduleMessageModal }
							selectedClientEmail = { selectedClientEmail}
							hideAddModal={this.hideAddModal}
							hideActionModal = { this.hideActionModal}
							hideScheduleMessageModal = { this.hideScheduleMessageModal}
							newGroupName={newGroupName}
							groups={Object.values(groups)}
							clients={Object.values(clients)}
							onSave={this.saveData}
							onChange={this.handleChange}
							onChangeGroupIds={type => this.handleFormChecks(type)}
							newClientId={newClientId}
							fetchMore= { this.fetchListing }
							fetchActions = {this.props.fetchActions}
							fetchMileStones = { this.props.fetchMileStones }
							fetchPARQS = { this.props.fetchPARQS }
							fetchScheduleCall = { this.props.fetchScheduleCall }
							saveBodyMatrix = {this.props.saveBodyMatrix}
							saveWeightMatric = {this.props.saveWeightMatric}
							deleteBodyMetric = { this.props.deleteBodyMetric }
							saveScheduleMessage = { this.props.saveScheduleMessage }
							deleteScheduleMessage = { this.props.deleteScheduleMessage }
							fetchScheduleMessages = { this.props.fetchScheduleMessages }
							fetchScheduleMessageDetail = {this.props.fetchScheduleMessageDetail}
							fetchBodyMatrixMetas = {this.props.fetchBodyMatrixMetas}
							fetchWeightMetricRanges = { this.props.fetchWeightMetricRanges }
							fetchBodyMatrixRanges = {this.props.fetchBodyMatrixRanges}
							deleteBodyMatrixRange = {this.props.deleteBodyMatrixRange}
							deleteWeightMetricRange = {this.props.deleteWeightMetricRange}
							saveClientAction = {this.props.saveClientAction}
							saveMileStones = { this.props.saveMileStones }
							savePARQ = { this.props.savePARQ }
							deleteMileStones = { this.props.deleteMileStones }
							deletePARQ = { this.props.deletePARQ }
							updateActionStatus = { this.props.updateActionStatus }
							saveScheduleCall = { this.props.saveScheduleCall }
							deleteActionRange = { this.props.deleteActionRange }
							deleteAction = { this.props.deleteClientAction }
							fetchActionRanges = { this.props.fetchActionRanges }
							fetchBodyMatrix = {this.props.fetchBodyMatrix}
							fetchWeightMetric =  {this.props.fetchWeightMetric}
							user = { this.props.user }
							isLoadMore = { clientType === 'clients' ? this.props.isClientsLoadMore : this.props.isGroupsLoadMore  }
						/>
						{/* <TextField
              rows={3}
              multiline={true}
              label="Message To Clients"
              value={formData.message}
              name="message"
              onChange={this.handleChange}
              margin="dense"
              variant="outlined"
              helperText="(Optional)"
            /> */}
					</div>
					<div style={{ width: '60%', paddingTop: 10, paddingBottom: 10 }}>
						<div style={{ paddingBottom: 10 }}>
							<ToggleButtonGroup
								value={this.state.itemType}
								onChange={this.handleToggleType}
								exclusive
							>
								<ToggleButton
									value="workout"
									selected={this.state.itemType === 'workout'}
								>
									Workouts
								</ToggleButton>
								<ToggleButton
									value="program"
									selected={this.state.itemType === 'program'}
								>
									Programs
								</ToggleButton>
								{ user && user.type.includes('brand') && (user.planOption === 2 || user.planOption === 5) && 
								   <ToggleButton
									  value="automation"
									  selected={this.state.itemType === 'automation'}
									  style={{marginLeft: '15px'}}
								    >
									  Automated Messages
								   </ToggleButton>
	                            }
								{ user && (user.type.includes('trainer') || user.type.includes('corporate'))  && 
								   <ToggleButton
									  value="automation"
									  selected={this.state.itemType === 'automation'}
									  style={{marginLeft: '15px'}}
								    >
									  Automated Messages
								   </ToggleButton>
	                            }
							</ToggleButtonGroup>
						</div>

						{ this.state.itemType === 'workout' && this.renderSelectionList()}
						{ this.state.itemType === 'program' && this.renderSelectionList()}
						{ this.state.itemType === 'automation' && this.renderSelectionList()}

						<Button
							onClick={() => this.submitForm()}
							variant="contained"
							color="primary"
							style={{ display: 'block', margin: 'auto', marginTop: 40 }}
						>
							Assign
						</Button>
						{ isOpenRestrictFeatureModal && 
						<RestrictFeature {...this.props} isOpenAddModal = { isOpenRestrictFeatureModal } hideAddModal = { () => {
							this.setState({
								isOpenRestrictFeatureModal: false
							})
						}}></RestrictFeature> }
					</div>
				</div>

				<Modal
					className="modal show"
					open={openAlreadyAssignModal}
					onClose={() => this.closeAssignModal()}
				>
					<div className="modalBody modal-content" style={{ width: 360 }}>
						<ModalHeading
							text={
								<div>
									Already Assigned{' '}
									{itemType === 'program' ? 'Programs' : 'Workouts'}
								</div>
							}
							closeModal={() => this.closeAssignModal()}
						/>
						<div className="modalContent">
							{alreadyAssignedList.map((assignlist, index) => (
								<div key={'assignItem-' + index}>
									<div
										style={{
											fontWeight: 'bold',
											marginTop: '10px',
										}}
									>
										<strong>{assignlist.name}</strong>
									</div>
									{assignlist.item.map((list, index) => (
										<div key={'assignList-' + index}>
											{' '}
											{list.clientEmail},{' '}
											<Moment className="text-muted" format="MM/DD/YYYY">
												{list.createdAt}
											</Moment>
										</div>
									))}
								</div>
							))}
						</div>
					</div>
				</Modal>
			</div>
		);
	}
}

export default ClientsForm;



// WEBPACK FOOTER //
// ./src/components/assignments/ClientsForm.js